// src/auth/reset-password-page.tsx
//
// Route: /reset-password. Flutter parity: reset_password_access_code →
// reset_password_new_password. The user arrives here from forgot-password with
// the emailed code; they verify it (LoginByCode) then set a new password
// (SetPassword). Email prefills from the forgot-password navigation state and
// stays editable; "Resend code" re-hits ForgotPassword. The two-step machine +
// the API calls live in the shared CodeToPasswordFlow.
import { useLocation, useNavigate } from 'react-router-dom';
import { CodeToPasswordFlow } from './code-to-password-flow';

interface ResetLocationState {
  email?: string;
}

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state ?? {}) as ResetLocationState;

  return (
    <CodeToPasswordFlow
      heading="Enter your reset code"
      intro="We emailed you a reset code. Enter it below with your email to continue."
      initialEmail={state.email ?? ''}
      emailEditable
      showResend
      submitLabel="Reset password"
      successMessage="Your password was reset. Sign in with your new password."
      onDone={(successMessage) => navigate('/', { state: { flash: successMessage } })}
    />
  );
}
